import React from "react";
import BookingsModule from "./bookings";
import TotalVisitsModule from "./totalVisits/index";
import AverageNumberOfVisitsPerClientModule from "./averageNumberOfVisitsPerClient/averageNumberOfVisitsPerClientNew/index";
import ActiveClientsModule from "./activeClients/index";
import ClassCount from "./classCount";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Attendance",
  configuratorWidth: { dark: 480, light: 380 },
  moduleList: [
    TotalVisitsModule,
    BookingsModule,
    AverageNumberOfVisitsPerClientModule,
    ActiveClientsModule,
    ClassCount
  ]
};

const AttendancePage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default AttendancePage;
